module.exports = __webpack_public_path__ + "static/media/2e123c1ab1e31167e08ac8a52daa377a.0a9a6625.png";